module.exports = __webpack_public_path__ + "static/img/first_post.0905d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/first_post.png
// module id = cVoK
// module chunks = 37